import { Scope } from "@ua/web-sdk/lib/remote-data/preference-center"
import axios, { AxiosInstance } from "axios"
import { throwIfNotSuccess } from "../../SubscriptionForm/client"

export type ContactListSubscription = {
  list_ids: string[]
  scope: Scope
}

type ContactListResponse = {
  ok: boolean
  subscription_lists: ContactListSubscription[]
}

export type ApiMutation = {
  action: "subscribe" | "unsubscribe"
  list_id: string
  scope: Scope
  timestamp: string
}

export default class ContactClient {
  contactId: string
  requester: AxiosInstance

  constructor(contactId: string, token: string) {
    if (!token.length) throw new Error("Invalid auth provided")
    if (!contactId.length) throw new Error("Invalid contact ID provided")
    this.contactId = contactId
    this.requester = axios.create({
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/vnd.urbanairship+json; version=3;",
      },
    })
  }

  async getLists(): Promise<ContactListSubscription[]> {
    const response = await this.requester.get<ContactListResponse>(
      `/api/subscription_lists/contacts/${this.contactId}`
    )
    throwIfNotSuccess(response)
    return response.data.subscription_lists
  }

  async updateLists(mutations: ApiMutation[]): Promise<void> {
    const response = await this.requester.post(
      `/api/contacts/${this.contactId}`,
      { subscription_lists: mutations }
    )

    throwIfNotSuccess(response)
  }
}
